import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

// eslint-disable-next-line import/no-cycle
import { FormError, Modal } from 'common/components/layout';
import { removeSpaces } from 'common/helpers/miscHelper';
import { integerFormat } from 'common/helpers/numberHelper';
import {
  editCustomerCreditCard,
  getCustomerCreditCard
} from 'redux/customerCreditCards/actions';

import AddEditForm from '../components/AddEditForm';
import { validateEdit } from '../validators';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  handleSubmit = async (form) => {
    this.setState({
      isSubmitting: true
    });
    const { props } = this;
    const { creditCardId } = this.props;
    const data = transformData(form);
    const { executeRecaptcha } = props.googleReCaptchaProps;
    const token = await executeRecaptcha('checkout');
    data.recaptchaToken = token;

    const successFunction = (creditCard) => {
      props.onEditCreditCard(creditCard);
    };
    props.editCustomerCreditCard(creditCardId, data, successFunction);
  };

  render() {
    const { settings, customerCreditCards } = this.props;
    const { handleSubmit, object, form } = this.props;
    const { onCloseModal, cancelFunction = onCloseModal } = this.props;
    const { isSubmitting } = this.state;

    if (!settings.data || !customerCreditCards.data) {
      return (
        <Modal title="Edit Credit Card" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    const cardsArr = Object.keys(customerCreditCards);
    const isFirstCard = cardsArr.length === 1 || false;

    return (
      <Modal title="Edit Credit Card" onCloseModal={onCloseModal}>
        <FormError formName={form} />
        <AddEditForm
          onSubmit={handleSubmit(this.handleSubmit)}
          saveButtonText={!isSubmitting ? 'Update Credit Card' : 'Loading...'}
          object={object}
          showCreditEdit={false}
          onCancelFunction={cancelFunction}
          isFirstCard={isFirstCard}
        />
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName,
    isDefault: values.isDefault
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateEdit(data);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  let formValues = {};
  if (state.customerCreditCard.data) {
    formValues = {
      ...state.customerCreditCard.data[ownProps.creditCardId]
    };
    formValues.expiryMo = formValues.expiryMo && formValues.expiryMo.toString();
    formValues.expiryYr = formValues.expiryYr && formValues.expiryYr.toString();
  }
  return {
    initialValues: formValues,
    object:
      state.customerCreditCard.data &&
      state.customerCreditCard.data[ownProps.creditCardId],
    isFetching: state.customerCreditCard.isFetching,
    settings: state.setting,
    customerCreditCards: state.customerCreditCard
  };
};

EditModal = reduxForm({
  form: 'EditModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(EditModal);

export default withGoogleReCaptcha(
  connect(mapStateToProps, {
    getCustomerCreditCard,
    editCustomerCreditCard
  })(EditModal)
);
